import post from '../../../../../fns/http/post'
import getHeaders from '../headers/index'

const loadEndDates = ({ month, nextMonth }, data, { urls, locale, headers, sessionId, responseProxy }) => {
    const params = {}
    if (nextMonth) {
        params.nextmonth = nextMonth
    }
    return post(`${urls.base.se}/search/enddates/${month}`, data, params, getHeaders({ locale, headers }), { responseProxy })
}
export default loadEndDates
